function init() {
  updateAnnouncementReviewsQuanity();
  setupCustomAccordions();
}

function updateAnnouncementReviewsQuanity() {
  const announcementBarReviews = document.querySelector('[js-announcement-bar="reviews"]');

  if (!announcementBarReviews) {
    return;
  }

  waitForElm('#reviews-io-rating-bar-widget').then((elm) => {
    const data = [...elm.querySelectorAll('.cssVar-reviewStatistics')];

    if (!data) {
      return;
    }

    const stars = data[0]
    const quantity = data[1]

    if (!stars && !quantity) {
      return;
    }

    announcementBarReviews.innerText = `${stars.innerText} BASED ON ${quantity.innerText} REVIEWS`;
  })
}

function setupCustomAccordions() {
  const accordionBtns = document.querySelectorAll(".accordion");
  
  accordionBtns.forEach((accordion) => {
    accordion.onclick = function () {
      this.classList.toggle("is-open");
  
      let content = this.nextElementSibling;
  
      content.classList.toggle("is-open");
  
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + 10 + "px";
      }
    };
  });
}

function hideZeroProductPrice() {
  const productPage = [...document.querySelectorAll('.template-product')];

  if (!productPage[0]) {
    return;
  }

  waitForElm('.cbb-price-digits').then((elm) => {
    const supTags = [...productPage[0].querySelectorAll('sup')];

    if (!supTags) {
      return;
    }

    supTags.forEach((sup) => {
      console.log(sup)
      
      if (sup.innerText.includes('00')) {
        sup.style.display = "none";
        sup.classList.add = "visually-hidden";
      }
    }) 
  })
}

function waitForElm(selector) {
  return new Promise(resolve => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }
  
    const observer = new MutationObserver(mutations => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });
  
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}

document.addEventListener("DOMContentLoaded", function(event) {
  init();  
})